import{useState as u}from"react";function l(e){let[t]=u(e);return t}export{l as useDefaultValue};
